var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("bk-input-label", [_vm._v(_vm._s(_vm.$t("STEP_ONE.AGE_OF.0")))]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "search-age" },
        [
          _c("bk-select", {
            attrs: {
              id: "from",
              fields: _vm.ageFromField,
              label: _vm.$t("STEP_ONE.AGE_OF.FROM"),
              width: "129px",
              value: _vm.valueFrom
            },
            on: {
              input: function($event) {
                return _vm.inputFrom($event)
              }
            }
          }),
          _vm._v(" "),
          _c("bk-select", {
            attrs: {
              id: "till",
              fields: _vm.ageToField,
              label: _vm.$t("STEP_ONE.AGE_OF.TO"),
              width: "129px",
              value: _vm.valueTo
            },
            on: {
              input: function($event) {
                return _vm.inputTill($event)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }